(function() {
    'use strict';

    angular
        .module('app.unidades')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/unidades',
                config: {
                    templateUrl: 'app/unidades/unidades.html',
                    controller: 'Unidades',
                    controllerAs: 'vm',
                    title: 'Unidades'
                }
            },
            {
                url: '/editar-unidad/:id?',
                config: {
                    templateUrl: 'app/unidades/editarUnidad.html',
                    controller: 'EditarUnidad',
                    controllerAs: 'vm',
                    title: 'EditarUnidad'
                }
            }
        ];
    }
})();
